import $ from 'jquery';
import {refreshUtmFields} from './form-utils.js';

export function initNewsletterInlineComponents(root = document) {
  root.querySelectorAll('[data-inline-newsletter]').forEach((component) => {
    if (component.dataset.inlineNewsletterInitialized === 'true') {
      return;
    }

    component.dataset.inlineNewsletterInitialized = 'true';

    component.querySelectorAll('.form-wrapper').forEach((formWrapper) => {
      formWrapper.addEventListener('click', (event) => {
        if (!event.target.closest('input, textarea, select')
          || !formWrapper.classList.contains('unfold')
          || formWrapper.classList.contains('unfolding')) {
          return;
        }

        const $formWrapper = $(formWrapper);

        $formWrapper.find('.formie-turnstile-placeholder > div').slideDown(1000);
        $formWrapper.find('.submit-button-wrapper').slideDown(1000);
        $formWrapper.find('.disclaimer').slideDown(1000, function () {
          $(this).css('display', 'block');
        });
        formWrapper.classList.add('unfolding');

        window.setTimeout(() => {
          formWrapper.classList.remove('unfold', 'unfolding');
          refreshUtmFields(formWrapper);
        }, 2000);
      });

      const form = formWrapper.querySelector('form');
      const thankYouMessage = document.getElementById(component.dataset.thankYouTarget);

      if (form && thankYouMessage) {
        $(form).on('onAfterFormieSubmit', (event) => {
          event.preventDefault();
          component.remove();
          thankYouMessage.hidden = false;
          $(thankYouMessage).hide().fadeIn(500);
        });
      }
    });
  });
}
